// src/api/axiosInstance.ts
import axios, { AxiosInstance } from 'axios';
import { BASE_API_URL, REQUEST_TIMEOUT } from './config';
import {
  // getAccessToken,
  getRestaurantId,
  // getRefreshToken,
  // setTokens,
  // clearTokens,
} from './tokenUtils';

/**
 * Get restaurant ID from localStorage only
 * Simple approach - no sessionStorage dependencies
 */
const getDynamicRestaurantId = (): string | null => {
  return getRestaurantId();
};


// Simple refresh token logic
// let isRefreshing = false;
// let failedQueue: Array<{
//   resolve: (value?: any) => void;
//   reject: (reason?: any) => void;
// }> = [];

// const processQueue = (error: any, token: string | null = null) => {
//   failedQueue.forEach(({ resolve, reject }) => {
//     if (error) {
//       reject(error);
//     } else {
//       resolve(token);
//     }
//   });

//   failedQueue = [];
// };

// Clean interceptor setup
const setupInterceptors = (
  instance: AxiosInstance,
  {
    requiresAuth = false,
    requiresRestaurantId = true,
  }: {
    requiresAuth?: boolean;
    requiresRestaurantId?: boolean;
  } = {}
) => {
  // Add token and restaurant ID to requests
  instance.interceptors.request.use(config => {
    // Add auth token if required
    if (requiresAuth) {
    //   const token = getAccessToken();
    //   if (token) {
    //     config.headers.Authorization = `Bearer ${token}`;
    //   }
    }
    // Add restaurant ID header by default
    if (requiresRestaurantId) {
      const restaurantId = getDynamicRestaurantId();
      if (restaurantId) {
        config.headers.restaurantid = restaurantId;
      }
    }

    return config;
  });

  // Handle 401 errors with token refresh
  instance.interceptors.response.use(
    response => response,
    async error => {
      // const originalRequest = error.config;

      // // Check if 401 error and we have refresh token
      // if (error.response?.status === 401 && getRefreshToken() && !originalRequest._retry) {

      //   // If already refreshing, queue this request
      //   if (isRefreshing) {
      //     return new Promise((resolve, reject) => {
      //       failedQueue.push({ resolve, reject });
      //     }).then((token) => {
      //       originalRequest.headers.Authorization = `Bearer ${token}`;
      //       return instance(originalRequest);
      //     });
      //   }

      //   originalRequest._retry = true;
      //   isRefreshing = true;

      //   try {
      //     // Refresh the token
      //     const response = await axios.post(ENV.REFRESH_URL, {
      //       refreshToken: getRefreshToken()
      //     }, {
      //       baseURL: ENV.API_BASE_URL,
      //       timeout: ENV.REFRESH_TIMEOUT
      //     });

      //     const { accessToken, refreshToken } = response.data;

      //     // Update tokens
      //     setTokens(accessToken, refreshToken);

      //     // Process queued requests
      //     processQueue(null, accessToken);

      //     // Retry original request
      //     originalRequest.headers.Authorization = `Bearer ${accessToken}`;
      //     return instance(originalRequest);

      //   } catch (refreshError) {
      //     // Refresh failed - clear tokens and reject all queued requests
      //     processQueue(refreshError, null);
      //     clearTokens();
      //     return Promise.reject(refreshError);
      //   } finally {
      //     isRefreshing = false;
      //   }
      // }

      return Promise.reject(error);
    }
  );
};

// Default axios instance
const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
  timeout: REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupInterceptors(axiosInstance, {});

// Function to create custom axios instance without caching
export const createAxiosInstance = ({
  baseURL,
  requiresAuth = false,
  timeout,
  requiresRestaurantId = true,
  ...rest
}: {
  baseURL?: string;
  requiresAuth?: boolean;
  timeout?: number;
  requiresRestaurantId?: boolean;
  [key: string]: unknown;
} = {}): AxiosInstance => {
  // Create new instance
  const customInstance = axios.create({
    baseURL: baseURL || BASE_API_URL,
    timeout: timeout || REQUEST_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
    ...rest,
  });

  // Setup interceptors
  setupInterceptors(customInstance, { requiresAuth, requiresRestaurantId });

  return customInstance;
};

export default axiosInstance;
